var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7839 20L31.0112 10L8.98884 10L4.21611 20L8.98883 30L31.0112 30L35.7839 20ZM32.2727 8L7.72727 8L2 20L7.72727 32L32.2727 32L38 20L32.2727 8ZM31 20C31 20.5523 30.5523 21 30 21C29.4477 21 29 20.5523 29 20C29 19.4477 29.4477 19 30 19C30.5523 19 31 19.4477 31 20ZM33 20C33 21.6569 31.6569 23 30 23C28.3431 23 27 21.6569 27 20C27 18.3431 28.3431 17 30 17C31.6569 17 33 18.3431 33 20ZM10 21C10.5523 21 11 20.5523 11 20C11 19.4477 10.5523 19 10 19C9.44771 19 9 19.4477 9 20C9 20.5523 9.44771 21 10 21ZM10 23C11.6569 23 13 21.6569 13 20C13 18.3431 11.6569 17 10 17C8.34314 17 7 18.3431 7 20C7 21.6569 8.34314 23 10 23ZM21 15C21 15.5523 20.5523 16 20 16C19.4477 16 19 15.5523 19 15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15ZM23 15C23 16.6569 21.6569 18 20 18C18.3431 18 17 16.6569 17 15C17 13.3431 18.3431 12 20 12C21.6569 12 23 13.3431 23 15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticJ);
export default __webpack_public_path__ + "static/media/DOMESTIC_J.86673645c8eb9864d55ff0f46d9ee355.svg";
export { ForwardRef as ReactComponent };